import React, { Component } from 'react';
import Dialog from '../../../../commonModules/interface/Dialog';
import Pagination from '../../../../commonModules/interface/Pagination';
import Spin from '../../../../commonModules/interface/Spin.jsx';
import { isEmpty } from "lodash";
import { TableRow, TableCell, Button, TableHead, TableBody, Card, Grid, Box, FormControlLabel, FormGroup, Switch, AppBar, Tabs, Tab, Tooltip } from '@material-ui/core';
import { TableLayout } from '../containers/Layout';
import { SearchRounded, AddShoppingCartRounded, ShoppingCartRounded, RemoveShoppingCartRounded, BlockRounded } from '@material-ui/icons';
import { toast } from 'react-toastify';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import InputText, { InputSelect, InputSelectNative } from '../../../../commonModules/interface/form-input-inline.jsx';
import Currency from '../../../../commonModules/Currency';
import AdoptProductDialog from './AdoptProductDialog';
import { filtrerProduits } from './filtrerProduits';

// Libellés des types de produit. Hissés hors du composant parce que la liste du
// catalogue s'en sert aussi : le serveur y renvoie la clé brute, et deux
// tableaux qui nomment différemment le même type se liraient mal.
const TYPES_PRODUIT = {
    "panneaux":"Panneaux Solaires",
    "regulateurs":"Régulateurs",
    "convertisseurs":"Convertisseurs",
    "convertisseurs_chargeurs":"Convertisseur-Chargeurs",
    "convertisseurs_chargeurs_MPPT":"Convertisseur-Chargeurs - MPPT",
    "convertisseurs_dc-dc":"Convertisseur DC-DC",
    "batteries":"Batteries",
    "cables":"Câbles",
    "lampes":"Lampes",
    "supervision":"Supervision",
    "kit":"Kits complet",
    "menager":"Equipement ménager",
    "pompes":"Pompes",
    "picos":"Picos",
    "accesoires":"Accessoires",
    "protection":"Protection",
    "autres":"Autres",
    "equipement_bt":"Equipement BT"
}

class ListProduct extends Component {
    state = {
        single:{
            id:"",
            name: "",
        },
        dialogStock: false,
        // Triée dès le premier affichage, et à chaque remontage : les produits
        // désactivés ne doivent pas attendre une recherche pour passer en fin
        // de liste.
        filteredList: filtrerProduits(this.props.PRODUCTS, this.props.AVAILABLE),
        search:{
            searchName: "",
            searchMarque: "",
            searchType: "",
            searchRef: "",
            inStock: false
        },

        // « Mes produits » reste le mode par défaut : l'écran est d'abord la
        // liste de travail du compte. Le catalogue est un détour volontaire.
        mode: "mine",
        catalogueSearch:{
            searchName: "",
            searchMarque: "",
            searchRef: "",
        },
        cataloguePage: 0,
        catalogueRowsPerPage: 20,
        adoptProduct: null,

        // Produit en attente de confirmation de désactivation : { id, name }.
        disableProduct: null,
        disabling: false,
    }

    componentDidUpdate(prevProps) {
        // filteredList est un instantané de PRODUCTS pris au montage. Après une
        // adoption, la liste du compte est relue et le store change : sans cette
        // réapplication des filtres, le produit tout juste ajouté n'apparaîtrait
        // qu'au premier caractère tapé dans la recherche.
        if (prevProps.PRODUCTS !== this.props.PRODUCTS) {
            this.filterList()
        }
    }

    filterList = (search = this.state.search) => {
        const { PRODUCTS, AVAILABLE } = this.props
        this.setState({
            filteredList: filtrerProduits(PRODUCTS, AVAILABLE, search)
        })
    }

    // FORM MANAGER ...
        handleSearch = (e) => {
            const { name, value } = e.target
            let newSearch = Object.assign({}, this.state.search)
            newSearch[name] = value

            this.setState({
                ...this.state,
                search: newSearch,
            })
            this.filterList(newSearch)
        }
        handleChecked = (e) => {
            const { name, checked } = e.target
            let newSearch = Object.assign({}, this.state.search)
            newSearch[name] = checked

            this.setState({
                ...this.state,
                search: newSearch,
            })
            this.filterList(newSearch)
        }

        createTypeList = () => {
            return Object.keys(TYPES_PRODUIT).map((key) => {
                return (
                    <option key={key} value={key} >{TYPES_PRODUIT[key]}</option>
                )
            })
        }

    // BASCULE MES PRODUITS / CATALOGUE ...
        handleMode = (e, mode) => {
            this.setState({ mode })

            // Le catalogue compte des milliers d'entrées : il n'est demandé au
            // serveur que si l'utilisateur va le voir, et une seule fois.
            const { CATALOGUE } = this.props
            if (mode === "catalogue" && CATALOGUE && !CATALOGUE.loaded && !CATALOGUE.loading) {
                this.props.fetchCatalogue()
            }
        }

        handleCatalogueSearch = (e) => {
            const { name, value } = e.target
            let newSearch = Object.assign({}, this.state.catalogueSearch)
            newSearch[name] = value

            // Retour à la première page : sur près de quatre mille produits, un
            // filtre posé depuis la page 30 ne laisserait sinon rien à afficher.
            this.setState({
                catalogueSearch: newSearch,
                cataloguePage: 0,
            })
        }

        onChangeCataloguePage = (pageOfItems, currentPage, rowsPerPage) => {
            // Le pied de tableau revient de lui-même à la première page quand on
            // change le nombre de lignes, tout en annonçant encore l'ancienne :
            // suivre ce qu'il affiche évite de montrer une page vide.
            const changementDeTaille = rowsPerPage !== this.state.catalogueRowsPerPage
            this.setState({
                cataloguePage: changementDeTaille ? 0 : currentPage,
                catalogueRowsPerPage: rowsPerPage,
            })
        }

        // Un produit déjà chez soi reste visible sans pouvoir être ajouté une
        // seconde fois : le chercher pour découvrir qu'on l'a déjà est une
        // perte de temps. Deux sources répondent à la question : le serveur au
        // chargement du catalogue, puis la liste des produits du compte.
        //
        // Quand le compte a la fiche, c'est elle qui tranche, dans les deux
        // sens : elle est relue, ou corrigée sur place, à chaque adoption et à
        // chaque désactivation, alors que l'entrée du catalogue peut dater du
        // chargement. Un produit désactivé n'est pas « adopté » : c'est ce qui
        // lui rend son bouton « Ajouter ».
        estAdopte = (produit) => {
            const { PRODUCTS } = this.props
            const fiche = PRODUCTS && PRODUCTS[produit.id]
            if (fiche) {
                return !fiche.is_disabled
            }
            return !!produit.deja_adopte
        }

        estDesactive = (produit) => {
            const { PRODUCTS } = this.props
            const fiche = PRODUCTS && PRODUCTS[produit.id]
            if (fiche) {
                return !!fiche.is_disabled
            }
            return !!produit.desactive
        }

        filterCatalogue = () => {
            const { CATALOGUE } = this.props
            const produits = (CATALOGUE && CATALOGUE.produits) || []
            const { searchName, searchMarque, searchRef } = this.state.catalogueSearch

            const vName = searchName.toLowerCase()
            const vMarque = searchMarque.toLowerCase()
            const vRef = searchRef.toLowerCase()

            return produits.filter( produit => {
                if (!isEmpty(searchName) && !(produit.name || "").toLowerCase().includes(vName)) {
                    return false
                }
                if (!isEmpty(searchMarque) && !(produit.marque || "").toLowerCase().includes(vMarque)) {
                    return false
                }
                if (!isEmpty(searchRef) && !(produit.ref || "").toLowerCase().includes(vRef)) {
                    return false
                }
                return true
            })
        }

    // ADOPTION ...
        openAdopt = (produit) => {
            this.setState({ adoptProduct: produit })
        }

        closeAdopt = () => {
            this.setState({ adoptProduct: null })
        }

    // DÉSACTIVATION ...
        // Stock restant du produit, tous magasins confondus : même calcul que
        // la colonne « En Stock ».
        stockRestant = (productID) => {
            const { AVAILABLE } = this.props
            let total = 0
            Object.values(AVAILABLE || {}).forEach( stock => {
                if (stock.product_id === productID && stock.quantity > 0) {
                    total += stock.quantity
                }
            })
            return total
        }

        openDisable = (produit) => {
            this.setState({ disableProduct: { id: produit.id, name: produit.name } })
        }

        closeDisable = () => {
            // Pendant l'envoi, le dialogue reste : le fermer laisserait croire
            // que le geste a été abandonné alors qu'il est parti.
            if (this.state.disabling) {
                return
            }
            this.setState({ disableProduct: null })
        }

        submitDisable = async () => {
            const { disableProduct, disabling } = this.state
            if (!disableProduct || disabling) {
                return
            }

            this.setState({ disabling: true })

            try {
                await this.props.disableCatalogueProduct(disableProduct.id)
                toast.info(disableProduct.name + " a été désactivé : il n'est plus proposé à la vente")
                this.setState({ disableProduct: null, disabling: false })
            } catch (err) {
                console.log("[ERROR] désactivation produit ", err)
                toast.error(err.message || "La désactivation du produit a échoué")
                this.setState({ disabling: false })
            }
        }

    createProductList = () => { // table
        const { PRODUCTS, rowsPerPage, currentPage, AVAILABLE } = this.props
        // return this.props.pageOfItems.map( ID => (
        return this.state.filteredList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((ID) => {
            let available = Object.values(AVAILABLE).filter( stock => stock.product_id === ID && stock.quantity > 0)
            let total =  0
            if (!isEmpty(available) ) {
                available.forEach( stock => total += stock.quantity)
            }

            // console.log({available, total});
            return (
            <TableRow
                key={ID}
                style={{
                    textDecoration: PRODUCTS[ID].is_disabled ? "line-through" : undefined,
                    color: PRODUCTS[ID].is_disabled ? "grey" : undefined,
                    fontStyle: PRODUCTS[ID].is_disabled ? "italic" : undefined,
                    textDecorationThickness: PRODUCTS[ID].is_disabled ? "2px" : "auto"
                }}
            >
                <TableCell>
                    <Button
                        startIcon={<SearchRounded />}
                        color="secondary"
                        variant="contained"
                        style={{width: "100%"}}
                        onClick={ () => this.setState({
                            dialogStock:true,
                            single:{
                                id: PRODUCTS[ID].id,
                                name: PRODUCTS[ID].name
                                }
                            })
                        }
                    >
                        {total}
                    </Button>
                </TableCell>
                <TableCell>{PRODUCTS[ID].ref}</TableCell>
                {PRODUCTS[ID].photos && PRODUCTS[ID].photos.length > 0 && PRODUCTS[ID].photos[0].filename &&
                    <TableCell className="lightbox-item p-item">
                        <img
                            id={PRODUCTS[ID].photos[0].filename}
                            src={`/stocks/photos/${PRODUCTS[ID].photos[0].filename}`}
                            style={{width:"100px", height:"auto"}}
                        />
                        {/* <img id={PRODUCTS[ID].photos[0].filename} src={PRODUCTS[ID].mainPhoto} style={{width:"100px", height:"auto"}}/> */}
                    </TableCell>
                }
                {(!PRODUCTS[ID].photos || PRODUCTS[ID].photos.length === 0 || !PRODUCTS[ID].photos[0] || !PRODUCTS[ID].photos[0].filename) &&
                    <TableCell className="lightbox-item p-item">
                        <img src="img/noImg.png" alt="" style={{width:"100px", height:"auto"}}/>
                    </TableCell>
                }
                <TableCell><a href="#" onClick={ () => this.props.handleSingle(PRODUCTS[ID]) }> {PRODUCTS[ID].name}</a></TableCell>
                <TableCell>{PRODUCTS[ID].marque}</TableCell>
                <TableCell><Currency value={PRODUCTS[ID].prix_venteHT} /></TableCell>
                <TableCell><Currency value={PRODUCTS[ID].prix_venteTTC} /></TableCell>
                {this.props.ecomActive && <TableCell style={{ textAlign: 'center' }}>
                    {PRODUCTS[ID].ecom_enabled
                        ? <Tooltip title="Synchronisation Prestashop activée"><ShoppingCartRounded style={{ color: '#4caf50', fontSize: 20 }} /></Tooltip>
                        : <Tooltip title="Prestashop non connecté"><RemoveShoppingCartRounded style={{ color: '#bdbdbd', fontSize: 20 }} /></Tooltip>
                    }
                </TableCell>}
            </TableRow>
        )})
    }

    createCatalogueList = (produits) => { // table
        const { cataloguePage, catalogueRowsPerPage } = this.state
        const debut = cataloguePage * catalogueRowsPerPage

        // Seule la page affichée est rendue : le catalogue entier compte des
        // milliers de lignes, en poser autant dans le DOM figerait l'écran.
        return produits.slice(debut, debut + catalogueRowsPerPage).map((produit) => {
            const adopte = this.estAdopte(produit)
            const desactive = !adopte && this.estDesactive(produit)
            // Un produit ne se désactive qu'une fois son stock à zéro : le
            // désactiver avec des unités en magasin les immobiliserait, plus
            // aucun formulaire ne les proposant à la vente. Le serveur refuse
            // de toute façon ; le dire ici évite un clic voué à l'échec.
            const stock = adopte ? this.stockRestant(produit.id) : 0

            return (
                <TableRow
                    key={produit.id}
                    style={{
                        color: adopte ? "grey" : undefined,
                        fontStyle: adopte ? "italic" : undefined,
                    }}
                >
                    <TableCell>{produit.ref}</TableCell>
                    <TableCell>{produit.name}</TableCell>
                    <TableCell>{produit.marque}</TableCell>
                    <TableCell>{TYPES_PRODUIT[produit.product_type] || produit.product_type}</TableCell>
                    <TableCell>
                        {adopte &&
                            <React.Fragment>
                                <span>Déjà dans mes produits</span>
                                <Box component="span" ml={1} style={{fontStyle: "normal"}}>
                                    <Button
                                        startIcon={<BlockRounded />}
                                        variant="outlined"
                                        size="small"
                                        disabled={stock > 0}
                                        onClick={() => this.openDisable(produit)}
                                    >
                                        Désactiver
                                    </Button>
                                </Box>
                                {stock > 0 &&
                                    <Box component="span" ml={1} style={{fontStyle: "normal"}}>
                                        <small>Stock : {stock} — à ramener à 0 pour désactiver</small>
                                    </Box>
                                }
                            </React.Fragment>
                        }
                        {desactive &&
                            <Box component="span" mr={1}>Désactivé</Box>
                        }
                        {!adopte &&
                            <Button
                                startIcon={<AddShoppingCartRounded />}
                                color="secondary"
                                variant="contained"
                                size="small"
                                onClick={() => this.openAdopt(produit)}
                            >
                                Ajouter
                            </Button>
                        }
                    </TableCell>
                </TableRow>
            )
        })
    }

    findStocks = () => {// find shops with stocks of this product
        let found = false;
        const { AVAILABLE, SHOPS } = this.props
        if(AVAILABLE){
            return[
                Object.values(AVAILABLE).filter(
                    stock => stock.product_id === this.state.single.id && stock.quantity > 0).map(
                        stock => {
                        found = true
                        return (
                            <TableRow key={stock.id}>
                                <TableCell>{SHOPS[stock.shop_id].name}</TableCell>
                                <TableCell>{SHOPS[stock.shop_id].city}</TableCell>
                                <TableCell>{stock.quantity}</TableCell>
                                {/* <TableCell>{stock.prix_revient}</TableCell> */}
                            </TableRow>
                        )
                }),
                found
            ]
        } else {
            return ["",false]
        }
    }


    render() {
        console.log("[STATE] List Products ",this.state);

        const { filteredList, mode, adoptProduct, disableProduct, disabling } = this.state
        const { CATALOGUE, PRODUCTS } = this.props
        console.log({filteredList});

        const catalogue = mode === "catalogue" ? this.filterCatalogue() : []

        const stockTable = (
            this.state.dialogStock === true &&
            <div>
                {this.findStocks()[1] &&
                    // <div className="table-responsive">
                    //     <table id="data-table-selection" className="table text-left">
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell>Shop</TableCell>
                                <TableCell>Ville</TableCell>
                                <TableCell>Quantité</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.findStocks()[0]}
                        </TableBody>

                    </TableLayout>
                    //     </table>
                    // </div>
                }
                {!this.findStocks()[1] &&
                    <div>
                        <span>Pas de stock disponible</span>
                        {/* <button className="btn btn-xs btn-primary" >
                            Nouveau stock
                        </button> */}
                    </div>
                }
            </div>
        )

        return (
            <React.Fragment>
                {this.state.dialogStock &&
                    <Dialog
                        block={this.state.dialogStock}
                        title={this.state.single.name}
                        text={ stockTable }
                        close={() => this.setState({
                            dialogStock:false,
                            single:{
                                id: "",
                                name: ""
                                }
                            })

                        }
                    />
                }
                {disableProduct &&
                    <Dialog
                        block={true}
                        title={"Désactiver : " + disableProduct.name}
                        close={this.closeDisable}
                        submit={
                            <Button
                                variant="contained"
                                color="secondary"
                                disabled={disabling}
                                onClick={this.submitDisable}
                            >
                                Désactiver
                            </Button>
                        }
                    >
                        {disabling && <Spin noOverlay />}
                        <Box p={1}>
                            <strong>{disableProduct.name}</strong> ne sera plus proposé lors
                            d'une nouvelle vente, d'un devis ou d'une réservation. Les
                            documents déjà enregistrés qui le citent ne changent pas.
                        </Box>
                        <Box p={1}>
                            Pour le réactiver : onglet Catalogue, bouton « Ajouter ».
                        </Box>
                    </Dialog>
                }
                {adoptProduct &&
                    <AdoptProductDialog
                        produit={adoptProduct}
                        // Réactivation : le compte a déjà la fiche, avec ses
                        // prix. Le dialogue les reprend plutôt que de les faire
                        // ressaisir.
                        fiche={PRODUCTS && PRODUCTS[adoptProduct.id]}
                        adoptCatalogueProduct={this.props.adoptCatalogueProduct}
                        close={this.closeAdopt}
                        onAdopted={this.closeAdopt}
                    />
                }
                <AppBar position="static">
                    <Tabs
                        value={mode}
                        onChange={this.handleMode}
                        indicatorColor="secondary"
                        variant="fullWidth"
                    >
                        <Tab value="mine" label="Mes produits" />
                        <Tab value="catalogue" label="Catalogue" />
                    </Tabs>
                </AppBar>

                {mode === "mine" &&
                <React.Fragment>
                <Card title="Recherche">
                    <Box p={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <InputText type="text" id="searchRef" onChange={this.handleSearch} value={this.state.search.searchRef} name="searchRef" title="Reference du produit"/>

                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputText type="text" id="searchName" onChange={this.handleSearch} value={this.state.search.searchName} name="searchName" title="Nom du produit"/>

                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <InputText type="text" id="searchMarque" onChange={this.handleSearch} value={this.state.search.searchMarque} name="searchMarque" title="Marque du produit"/>

                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <InputSelectNative
                                    id="searchType"
                                    onChange={this.handleSearch}
                                    value={this.state.search.searchType}
                                    name="searchType"
                                    title="Type"
                                    options={this.createTypeList()}
                                    labelWidth={60}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box p={1}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={this.state.search.inStock}
                                                onChange={this.handleChecked}
                                                name="inStock"
                                                color="secondary"
                                            />
                                        }
                                        label="Produits en stock seulement"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                </Card>
                {!isEmpty(filteredList) &&
                    <TableLayout>
                        <TableHead>
                            <TableRow style={{ textAlign: "center"}}>
                                <TableCell component="th">En Stock</TableCell>
                                <TableCell component="th">Réference</TableCell>
                                <TableCell component="th">Photo</TableCell>
                                <TableCell component="th">Nom</TableCell>
                                <TableCell component="th">Marque</TableCell>
                                <TableCell component="th">Prix HT</TableCell>
                                <TableCell component="th">Prix TTC</TableCell>
                                {this.props.ecomActive && <TableCell component="th" style={{ textAlign: 'center' }}>
                                    <Tooltip title="Synchronisation Prestashop (ECom-MJB-Connect)">
                                        <ShoppingCartRounded style={{ fontSize: 18, verticalAlign: 'middle', color: '#666' }} />
                                    </Tooltip>
                                </TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.createProductList()}
                        </TableBody>
                        <TableFooterPagination
                            colSpan={7}
                            items={filteredList}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPage}
                        />
                    </TableLayout>

                }

                {isEmpty(filteredList) &&
                    <div className="text-center">
                        <h5>Pas de produit</h5>
                        cliquez sur
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={ this.props.handleNew}
                        >
                            Nouveau
                        </Button> pour entrer un nouveau produit
                    </div>
                }
                </React.Fragment>
                }

                {mode === "catalogue" &&
                <React.Fragment>
                <Card title="Recherche">
                    <Box p={2}>
                        <Box p={1}>
                            <span>
                                Le catalogue rassemble les fiches produit de la plateforme. Ajouter
                                l'une d'elles à votre compte revient à lui donner votre prix : la
                                fiche, elle, reste commune.
                            </span>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <InputText type="text" id="catalogueRef" onChange={this.handleCatalogueSearch} value={this.state.catalogueSearch.searchRef} name="searchRef" title="Reference du produit"/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputText type="text" id="catalogueName" onChange={this.handleCatalogueSearch} value={this.state.catalogueSearch.searchName} name="searchName" title="Nom du produit"/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputText type="text" id="catalogueMarque" onChange={this.handleCatalogueSearch} value={this.state.catalogueSearch.searchMarque} name="searchMarque" title="Marque du produit"/>
                            </Grid>
                        </Grid>
                    </Box>
                </Card>

                {CATALOGUE && CATALOGUE.loading && <Spin noOverlay />}

                {CATALOGUE && CATALOGUE.error &&
                    <div className="text-center">
                        <h5>{CATALOGUE.error}</h5>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => this.props.fetchCatalogue()}
                        >
                            Réessayer
                        </Button>
                    </div>
                }

                {!isEmpty(catalogue) &&
                    <TableLayout>
                        <TableHead>
                            <TableRow style={{ textAlign: "center"}}>
                                <TableCell component="th">Réference</TableCell>
                                <TableCell component="th">Nom</TableCell>
                                <TableCell component="th">Marque</TableCell>
                                <TableCell component="th">Type</TableCell>
                                <TableCell component="th">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.createCatalogueList(catalogue)}
                        </TableBody>
                        <TableFooterPagination
                            colSpan={5}
                            items={catalogue}
                            onChangePage={this.onChangeCataloguePage}
                            initialPage={this.state.cataloguePage}
                        />
                    </TableLayout>
                }

                {isEmpty(catalogue) && CATALOGUE && CATALOGUE.loaded && !CATALOGUE.error &&
                    <div className="text-center">
                        <h5>Aucun produit du catalogue ne correspond à cette recherche</h5>
                    </div>
                }
                </React.Fragment>
                }

                {/* <div className="text-center">
                    {this.props.reloadPagination && // force Pagination Update
                        <Pagination
                            items={filteredList}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPage}
                            pageSize={15}
                        />
                    }
                    {!this.props.reloadPagination &&
                        <Pagination
                            items={filteredList}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPage}
                            pageSize={15}
                        />
                    }
                </div> */}

            </React.Fragment>

        );
    }
}

export default ListProduct;
